import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

declare const __BUILD_TIME_STAMP__: string;

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', `.json?${__BUILD_TIME_STAMP__}`);
}
